const USDA_KEY = process.env.REACT_APP_USDA_API_KEY || 'DEMO_KEY';

function round(v, d = 1) {
  try { return Math.round(parseFloat(v) * 10 ** d) / 10 ** d; }
  catch { return 0; }
}

function normalizeUSDA(item) {
  try {
    const nutrients = {};
    for (const n of item.foodNutrients || []) {
      if (n.value != null) nutrients[n.nutrientName] = n.value;
    }
    const cal = nutrients['Energy'] || nutrients['Energy (Atwater General Factors)'] || 0;
    const serving = item.servingSize
      ? `${Math.round(item.servingSize)} ${item.servingSizeUnit || 'g'}`
      : '100 g';
    return {
      id: `usda_${item.fdcId}`,
      source: 'usda',
      external_id: String(item.fdcId || ''),
      name: (item.description || 'Unknown').replace(/\b\w/g, (c) => c.toUpperCase()),
      brand: item.brandOwner || item.brandName || 'USDA',
      serving,
      calories: round(cal),
      carbs: round(nutrients['Carbohydrate, by difference'] || 0),
      fat: round(nutrients['Total lipid (fat)'] || 0),
      protein: round(nutrients['Protein'] || 0),
      sugar: round(nutrients['Sugars, total including NLEA'] || nutrients['Total Sugars'] || 0),
      fiber: round(nutrients['Fiber, total dietary'] || 0),
      sodium: round(nutrients['Sodium, Na'] || 0),
    };
  } catch {
    return null;
  }
}

function normalizeOFF(item) {
  try {
    const n = item.nutriments || {};
    const cal = n['energy-kcal_100g'] ?? n['energy-kcal_serving'];
    if (cal == null) return null;
    const name = (item.product_name || item.generic_name || '').trim();
    if (!name) return null;
    return {
      id: `off_${item.code || Math.random().toString(36).slice(2)}`,
      source: 'off',
      external_id: String(item.code || ''),
      name,
      brand: (item.brands || 'Open Food Facts').split(',')[0].trim(),
      serving: item.serving_size || '100 g',
      calories: round(cal),
      carbs: round(n.carbohydrates_100g || 0),
      fat: round(n.fat_100g || 0),
      protein: round(n.proteins_100g || 0),
      sugar: round(n.sugars_100g || 0),
      fiber: round(n.fiber_100g || 0),
      sodium: round((n.sodium_100g || 0) * 1000),
    };
  } catch {
    return null;
  }
}

export async function searchFood(q, limit = 25) {
  if (!q.trim()) return [];
  const results = [];

  await fetch(
    `https://api.nal.usda.gov/fdc/v1/foods/search?api_key=${USDA_KEY}&query=${encodeURIComponent(q)}&pageSize=${Math.min(limit, 25)}&dataType=Branded,SR%20Legacy,Foundation`
  )
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      for (const item of (data?.foods || []).slice(0, limit)) {
        const norm = normalizeUSDA(item);
        if (norm) results.push(norm);
      }
    })
    .catch(() => {});

  const seen = new Set();
  const deduped = [];
  for (const r of results) {
    const key = `${r.name.toLowerCase()}|${(r.brand || '').toLowerCase()}`;
    if (!seen.has(key)) {
      seen.add(key);
      deduped.push(r);
    }
  }

  const ql = q.toLowerCase();
  deduped.sort((a, b) => {
    const aMatch = a.name.toLowerCase().startsWith(ql) ? 0 : 1;
    const bMatch = b.name.toLowerCase().startsWith(ql) ? 0 : 1;
    if (aMatch !== bMatch) return aMatch - bMatch;
    return a.source === 'usda' ? -1 : 1;
  });

  return deduped.slice(0, limit);
}

export const todayStr = () => new Date().toISOString().slice(0, 10);
